import React from "react";
import DropdownSearch from "../DropdownSearch/DropdownSearch";
import SearchInputsMap from "../SearchInputsMap/SearchInputsMap";

const AllSearchInputs = ({
  isLoading,
  searchParams,
  setSearchParams,
  storeNames,
  isAdvancedFilter,
  fringeBenefitsSubCategories,
}) => {
  const isDisabled = isLoading ? "opacity-80 pointer-events-none" : "";

  return (
    <>
      {/* <DropdownSearch
        isDisabled={isDisabled}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        storeNames={storeNames}
      /> */}

      {/* {isFringeBenefitsPage && (
        <>
          <div className="mb-3">
            <div className="font-bold mb-3">{localeText("subcategories")}</div>

            <Dropdown
              value={searchParams.area}
              onChange={(e) => setSearchParams((prev) => ({ ...prev, area: e.value.code }))}
              options={fringeBenefitsSubCategories}
              optionLabel="name"
              placeholder={localeText("subcategories")}
              className="w-full"
            />
          </div>
          <hr className="my-4" />
        </>
      )} */}

      <SearchInputsMap
        isDisabled={isDisabled}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        isAdvancedFilter={isAdvancedFilter}
      />
    </>
  );
};

export default AllSearchInputs;
